/**
 * @fileoverview POST handler for the "/engagement/reorder_in_app_messages" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { engagementReorderInAppMessagesCacheKeys } from "./constants";
import type { PostEngagementReorderInAppMessagesProps, EngagementReorderInAppMessagesResult } from "./types";

export const postEngagementReorderInAppMessages = reactQueryMutationAdapter(
  engagementReorderInAppMessagesCacheKeys,
  ({
    appGroupId,
    itemBeingEditedId,
    itemIdsByPriorityBucket,
    pinnedItemId,
  }: PostEngagementReorderInAppMessagesProps): Promise<EngagementReorderInAppMessagesResult> => {
    return fetch(
      "/engagement/reorder_in_app_messages",
      "POST",
      {
        app_group_id: appGroupId,
        items_with_iams_ids: itemIdsByPriorityBucket,
        item_being_edited_id: itemBeingEditedId,
        pinned_item_id: pinnedItemId,
      },
      undefined,
      {
        // don't display a modal on fetch errors
        propagateFetchRequestError: false,
      }
    );
  }
);
